import * as actionTypes from "./actionTypes";
import { updateObject } from "../../util/updateObject";
import {
  createBarringDataInitialState,
  currentBarringInitialState,
} from "./helper";

const initialState = {
  disabilitazioneChiamate: {
    data: [],
    lastUpdated: "",
    loading: false,
  },
  exportDisabilitazioneChiamateLoading: false,
  createDeleteBarringLoading: false,
  currentBarring: currentBarringInitialState,
  createBarringData: createBarringDataInitialState,
};

const setDisabilitazioneChiamate = (state, action) => {
  return updateObject(state, {
    disabilitazioneChiamate: updateObject(state.disabilitazioneChiamate, {
      [action.key]: action.value,
    }),
  });
};

const setExportDisabilitazioneChiamateLoading = (state, action) => {
  return updateObject(state, {
    exportDisabilitazioneChiamateLoading: action.value,
  });
};

const setCreateDeleteBarringLoading = (state, action) => {
  return updateObject(state, {
    createDeleteBarringLoading: action.value,
  });
};

const setCurrentBarring = (state, action) => {
  return updateObject(state, {
    currentBarring: updateObject(state.currentBarring, {
      [action.key]: action.value,
    }),
  });
};

const setCreateBarringData = (state, action) => {
  return updateObject(state, {
    createBarringData: updateObject(state.createBarringData, {
      [action.key]: action.value,
    }),
  });
};

const disabilitazioneChiamateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_DISABILITAZIONE_CHIAMATE_AND_LOADING:
      return setDisabilitazioneChiamate(state, action);
    case actionTypes.EXPORT_DISABILITAZIONE_CHIAMATE_LOADING:
      return setExportDisabilitazioneChiamateLoading(state, action);
    case actionTypes.CREATE_UPDATE_DELETE_BARRING:
      return setCreateDeleteBarringLoading(state, action);
    case actionTypes.GET_BARRING_BY_ID:
      return setCurrentBarring(state, action);
    case actionTypes.GET_CREATE_BARRING_DATA:
      return setCreateBarringData(state, action);
    default:
      return state;
  }
};

export default disabilitazioneChiamateReducer;
